var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135px",
    height: "40px",
    viewBox: "0 0 135 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "51332B81-C959-4E3A-8B3B-65D5F6A6A663") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "90.7307692%",
    y1: "4.82%",
    x2: "-38.3692308%",
    y2: "71.948%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: "0.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: "26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: "51.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.724138%",
    y1: "50%",
    x2: "-130.669951%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "40.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500",
    offset: "77.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.3233533%",
    y1: "17.7289229%",
    x2: "-49.9520958%",
    y2: "194.30434%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31162",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.7964072%",
    y1: "-54.2475923%",
    x2: "42.0598802%",
    y2: "24.9730607%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA771",
    offset: "6.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CF74",
    offset: "47.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E775",
    offset: "80.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1147---Download-icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1147-NA-Scroll",
    transform: "translate(-76.000000, -526.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App",
    transform: "translate(0.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay",
    transform: "translate(0.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Panel",
    transform: "translate(56.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav",
    transform: "translate(0.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DownloadList",
    transform: "translate(20.000000, 394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Item"
  }, /*#__PURE__*/React.createElement("g", {
    id: "badge_googleplay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,40 L5,40 C2.2,40 0,37.8 0,35 L0,5 C0,2.2 2.2,0 5,0 L130,0 C132.8,0 135,2.2 135,5 L135,35 C135,37.8 132.8,40 130,40 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,0.8 C132.3,0.8 134.2,2.7 134.2,5 L134.2,35 C134.2,37.3 132.3,39.2 130,39.2 L5,39.2 C2.7,39.2 0.8,37.3 0.8,35 L0.8,5 C0.8,2.7 2.7,0.8 5,0.8 L130,0.8 Z M130,0 L5,0 C2.2,0 0,2.3 0,5 L0,35 C0,37.8 2.2,40 5,40 L130,40 C132.8,40 135,37.8 135,35 L135,5 C135,2.3 132.8,0 130,0 Z",
    id: "Shape",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4,10.2 C47.4,11 47.2,11.7 46.7,12.2 C46.1,12.8 45.4,13.1 44.5,13.1 C43.6,13.1 42.9,12.8 42.3,12.2 C41.7,11.6 41.4,10.9 41.4,10 C41.4,9.1 41.7,8.4 42.3,7.8 C42.9,7.2 43.6,6.9 44.5,6.9 C44.9,6.9 45.3,7 45.7,7.2 C46.1,7.4 46.4,7.6 46.6,7.9 L46.1,8.4 C45.7,7.9 45.2,7.7 44.5,7.7 C43.9,7.7 43.3,7.9 42.9,8.4 C42.4,8.8 42.2,9.4 42.2,10.1 C42.2,10.8 42.4,11.4 42.9,11.8 C43.4,12.2 43.9,12.5 44.5,12.5 C45.2,12.5 45.7,12.3 46.2,11.8 C46.5,11.5 46.7,11.1 46.7,10.6 L44.5,10.6 L44.5,9.8 L47.4,9.8 L47.4,10.2 Z M52,7.7 L49.3,7.7 L49.3,9.6 L51.8,9.6 L51.8,10.3 L49.3,10.3 L49.3,12.2 L52,12.2 L52,13 L48.5,13 L48.5,7 L52,7 L52,7.7 Z M55.3,13 L54.5,13 L54.5,7.7 L52.8,7.7 L52.8,7 L57,7 L57,7.7 L55.3,7.7 L55.3,13 Z M59.9,13 L59.9,7 L60.7,7 L60.7,13 L59.9,13 Z M64.1,13 L63.3,13 L63.3,7.7 L61.6,7.7 L61.6,7 L65.7,7 L65.7,7.7 L64,7.7 L64.1,13 Z M73.6,12.2 C73,12.8 72.3,13.1 71.4,13.1 C70.5,13.1 69.8,12.8 69.2,12.2 C68.6,11.6 68.3,10.9 68.3,10 C68.3,9.1 68.6,8.4 69.2,7.8 C69.8,7.2 70.5,6.9 71.4,6.9 C72.3,6.9 73,7.2 73.6,7.8 C74.2,8.4 74.5,9.1 74.5,10 C74.5,10.9 74.2,11.6 73.6,12.2 Z M69.8,11.7 C70.2,12.1 70.8,12.4 71.4,12.4 C72,12.4 72.6,12.2 73,11.7 C73.4,11.3 73.7,10.7 73.7,10 C73.7,9.3 73.5,8.7 73,8.3 C72.6,7.9 72,7.6 71.4,7.6 C70.8,7.6 70.2,7.8 69.8,8.3 C69.4,8.7 69.1,9.3 69.1,10 C69.1,10.7 69.3,11.3 69.8,11.7 Z M75.6,13 L75.6,7 L76.5,7 L79.4,11.7 L79.4,7 L80.2,7 L80.2,13 L79.4,13 L76.3,8.1 L76.3,13 L75.6,13 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,21.8 C65.7,21.8 63.8,23.6 63.8,26.1 C63.8,28.5 65.7,30.4 68.1,30.4 C70.5,30.4 72.4,28.6 72.4,26.1 C72.4,23.5 70.5,21.8 68.1,21.8 Z M68.1,28.6 C66.8,28.6 65.7,27.5 65.7,26 C65.7,24.5 66.8,23.4 68.1,23.4 C69.4,23.4 70.5,24.4 70.5,26 C70.5,27.5 69.4,28.6 68.1,28.6 Z M58.8,21.8 C56.4,21.8 54.5,23.6 54.5,26.1 C54.5,28.5 56.4,30.4 58.8,30.4 C61.2,30.4 63.1,28.6 63.1,26.1 C63.1,23.5 61.2,21.8 58.8,21.8 Z M58.8,28.6 C57.5,28.6 56.4,27.5 56.4,26 C56.4,24.5 57.5,23.4 58.8,23.4 C60.1,23.4 61.2,24.4 61.2,26 C61.2,27.5 60.1,28.6 58.8,28.6 Z M47.7,23.1 L47.7,24.9 L52,24.9 C51.9,25.9 51.5,26.7 51,27.2 C50.4,27.8 49.4,28.5 47.7,28.5 C45,28.5 43,26.4 43,23.7 C43,21 45.1,18.9 47.7,18.9 C49.1,18.9 50.2,19.5 51,20.2 L52.3,18.9 C51.2,17.9 49.8,17.1 47.8,17.1 C44.2,17.1 41.1,20.1 41.1,23.7 C41.1,27.3 44.2,30.3 47.8,30.3 C49.8,30.3 51.2,29.7 52.4,28.4 C53.6,27.2 54,25.5 54,24.2 C54,23.8 54,23.4 53.9,23.1 L47.7,23.1 Z M93.1,24.5 C92.7,23.5 91.7,21.8 89.5,21.8 C87.3,21.8 85.5,23.5 85.5,26.1 C85.5,28.5 87.3,30.4 89.7,30.4 C91.6,30.4 92.8,29.2 93.2,28.5 L91.8,27.5 C91.3,28.2 90.7,28.7 89.7,28.7 C88.7,28.7 88.1,28.3 87.6,27.4 L93.3,25 L93.1,24.5 Z M87.3,25.9 C87.3,24.3 88.6,23.4 89.5,23.4 C90.2,23.4 90.9,23.8 91.1,24.3 L87.3,25.9 Z M82.6,30 L84.5,30 L84.5,17.5 L82.6,17.5 L82.6,30 Z M79.6,22.7 C79.1,22.2 78.3,21.7 77.3,21.7 C75.2,21.7 73.2,23.6 73.2,26 C73.2,28.4 75.1,30.2 77.3,30.2 C78.3,30.2 79.1,29.7 79.5,29.2 L79.6,29.2 L79.6,29.8 C79.6,31.4 78.7,32.3 77.3,32.3 C76.2,32.3 75.4,31.5 75.2,30.8 L73.6,31.5 C74.1,32.6 75.3,34 77.4,34 C79.6,34 81.4,32.7 81.4,29.6 L81.4,22 L79.6,22 L79.6,22.7 Z M77.4,28.6 C76.1,28.6 75,27.5 75,26 C75,24.5 76.1,23.4 77.4,23.4 C78.7,23.4 79.7,24.5 79.7,26 C79.7,27.5 78.7,28.6 77.4,28.6 Z M101.8,17.5 L97.3,17.5 L97.3,30 L99.2,30 L99.2,25.3 L101.8,25.3 C103.9,25.3 105.9,23.8 105.9,21.4 C105.9,19 103.9,17.5 101.8,17.5 Z M101.9,23.5 L99.2,23.5 L99.2,19.2 L101.9,19.2 C103.3,19.2 104.1,20.4 104.1,21.3 C104,22.4 103.2,23.5 101.9,23.5 Z M113.4,21.7 C112,21.7 110.6,22.3 110.1,23.6 L111.8,24.3 C112.2,23.6 112.8,23.4 113.5,23.4 C114.5,23.4 115.4,24 115.5,25 L115.5,25.1 C115.2,24.9 114.4,24.6 113.6,24.6 C111.8,24.6 110,25.6 110,27.4 C110,29.1 111.5,30.2 113.1,30.2 C114.4,30.2 115,29.6 115.5,29 L115.6,29 L115.6,30 L117.4,30 L117.4,25.2 C117.2,23 115.5,21.7 113.4,21.7 Z M113.2,28.6 C112.6,28.6 111.7,28.3 111.7,27.5 C111.7,26.5 112.8,26.2 113.7,26.2 C114.5,26.2 114.9,26.4 115.4,26.6 C115.2,27.8 114.2,28.6 113.2,28.6 Z M123.7,22 L121.6,27.4 L121.5,27.4 L119.3,22 L117.3,22 L120.6,29.6 L118.7,33.8 L120.6,33.8 L125.7,22 L123.7,22 Z M106.9,30 L108.8,30 L108.8,17.5 L106.9,17.5 L106.9,30 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,7.5 C10.1,7.8 10,8.3 10,8.9 L10,31 C10,31.6 10.2,32.1 10.5,32.4 L10.6,32.5 L23,20.1 L23,19.9 L10.4,7.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,24.3 L22.9,20.2 L22.9,19.9 L27,15.8 L27.1,15.9 L32,18.7 C33.4,19.5 33.4,20.8 32,21.6 L27,24.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1,24.2 L22.9,20 L10.4,32.5 C10.9,33 11.6,33 12.5,32.6 L27.1,24.2",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1,15.8 L12.5,7.5 C11.6,7 10.9,7.1 10.4,7.6 L22.9,20 L27.1,15.8 Z",
    id: "Shape",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,24.1 L12.5,32.3 C11.7,32.8 11,32.7 10.5,32.3 L10.4,32.4 L10.5,32.5 C11,32.9 11.7,33 12.5,32.5 L27,24.1 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,32.3 C10.1,32 10,31.5 10,30.9 L10,31 C10,31.6 10.2,32.1 10.5,32.4 L10.5,32.3 L10.4,32.3 Z M32,21.3 L27,24.1 L27.1,24.2 L32,21.4 C32.7,21 33,20.5 33,20 C33,20.5 32.6,20.9 32,21.3 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,7.6 L32,18.7 C32.6,19.1 33,19.5 33,20 C33,19.5 32.7,19 32,18.6 L12.5,7.6 C11.1,6.7 10,7.3 10,8.9 L10,9 C10,7.5 11.1,6.8 12.5,7.6 Z",
    id: "Shape",
    fill: "#FFFFFF",
    opacity: 0.25
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeGoogleplay);
export default __webpack_public_path__ + "static/media/badge_googleplay.9ca8239e6a0a69887c5fc7f7a00aeb44.svg";
export { ForwardRef as ReactComponent };